import {
  getPromptCollectList,
  createPromptCollect,
  updatePromptCollect,
  deletePromptCollect,
  applyPromptCollect,
} from '@/pages/opinion/services/aiTask';
import { getUserPrompt, setUserPrompt } from '@/pages/opinion/services';
import { useEffect, useState } from 'react';
import { notification } from 'tea-component';
import { PromptType } from '@op/components/GPT/types';
import { getPromptText } from '@op/components/GPT/utils';
import useLanguage from '@op/hooks/useLanguage';

export default function usePromptCollect({
  gameInfo,
  promptList,
}: {
  gameInfo: any;
  promptList: Array<PromptType>;
}) {
  const [userPromptList, setUserPromptList] = useState<any[]>([]);
  const [savedPromptList, setSavedPromptList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const { formatMessage } = useLanguage();

  useEffect(() => {
    getUserHistoryPrompt();
    getSavedPromptList();
  }, [gameInfo?.edition_unified_id]);

  const getUserHistoryPrompt = () => {
    if (gameInfo?.edition_unified_id) {
      setLoading(true);
      getUserPrompt({
        edition_unified_id: gameInfo.edition_unified_id,
        page: 1,
        page_size: 20,
      })
        .then(data => {
          setUserPromptList(data || []);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const getSavedPromptList = () => {
    if (gameInfo?.edition_unified_id) {
      getPromptCollectList({
        edition_unified_id: gameInfo.edition_unified_id,
        page: 1,
        page_size: 20,
      }).then((data: any) => {
        setSavedPromptList(data?.list || []);
      });
    }
  };

  const setUserHistoryPrompt = (value: string) => {
    // const flag = promptList.some(item => getPromptText(item) === value);
    // const historyFlag = userPromptList.some(
    //   (item: any) => item.prompt_detail === value,
    // );
    // if (flag || historyFlag) return;
    if (!value) return;

    setUserPrompt({
      edition_unified_id: gameInfo.edition_unified_id,
      prompt: value,
    }).then(() => {
      getUserHistoryPrompt();
    });
  };

  const savePrompt = (promptName: string, promptText: string) => {
    if (!promptText) return Promise.resolve(null);
    return createPromptCollect({
      edition_unified_id: gameInfo.edition_unified_id,
      prompt_name: promptName,
      prompt_detail: promptText,
    })
      .then((data: any) => {
        notification.success({
          description: formatMessage({ id: 'Prompt saved successfully' }),
        });
        getSavedPromptList();
        return data;
      })
      .catch((error: any) => {
        const errorCode = error?.data?.error_code || error?.code;
        if (errorCode === 30001) {
          return Promise.reject({ code: 30001 });
        }
        notification.error({
          description: formatMessage({ id: 'Prompt save failed' }),
        });
        return Promise.reject(error);
      });
  };

  const updatePrompt = (id: string, promptName: string, promptText: string) => {
    if (!promptText || !id) return Promise.resolve(null);
    return updatePromptCollect({
      id,
      edition_unified_id: gameInfo.edition_unified_id,
      prompt_name: promptName,
      prompt_detail: promptText,
    }).then((data: any) => {
      notification.success({
        description: formatMessage({ id: 'Prompt updated successfully' }),
      });
      getSavedPromptList();
      return data;
    });
  };

  const deletePrompt = (id: string) => {
    if (!id) return Promise.resolve(null);
    return deletePromptCollect({
      id,
      edition_unified_id: gameInfo.edition_unified_id,
    }).then((data: any) => {
      notification.success({
        description: formatMessage({ id: 'Prompt deleted successfully' }),
      });
      getSavedPromptList();
      return data;
    });
  };

  const applyPrompt = (id: string) => {
    if (!id) return Promise.resolve(null);
    return applyPromptCollect({
      id,
      edition_unified_id: gameInfo.edition_unified_id,
    });
  };

  return {
    loading,
    userPromptList,
    savedPromptList,
    setUserHistoryPrompt,
    getUserHistoryPrompt,
    getSavedPromptList,
    savePrompt,
    updatePrompt,
    deletePrompt,
    applyPrompt,
  };
}
